export const paras = [
  {
    header: 'Where Can I Find A Cleaning Lady Job?',
    para:
      'If you notice that you have a knack for keeping clean or enjoy tidying up around the home, you can turn something that you are good at into something you can do for money with a cleaning lady job. However, perhaps you are wondering how to find a cleaning lady job. There a few ways that you can start looking for a job in this field.',
  },
  {
    header: 'Begin working with friends or relatives',
    para:
      'The first thing on your housekeeper list should be a reference. However, few people aside from your friends and family members may give you a chance to working a cleaning lady job without prior work experience. Make sure that you always keep the original letters yourself and do not give them to prospective employers. Once you have a reference or two, you now have to decide whether you want to find a cleaning lady job with an employer or want to work for yourself.',
  },
  {
    header: 'Call the local cleaning services',
    para:
      'Even today with the constant influx of online applications, one of the best ways of finding a cleaning lady job is by calling the local cleaning services in your immediate area and see if they are hiring. Especially if you have little to no experience, actively seeking out companies and getting them on the phone may increase the odds of you getting your foot in the door. If you want a quick overview of some the more prominent cleaning agencies available, you can check out Housekeeper.com.',
  },
  {
    header: 'Look at some alternative local options',
    para:
      'It is important to remember that a cleaning lady job is not limited to actual cleaning services, hotels, hospitals, and offices all need staff that is able to clean their premises. Some of these options may only work with cleaning services while others can actually take on staff. Remember that letting people know that you are interested and available is an important step in transitioning into this line of work.',
  },
  {
    header: 'Look online',
    para:
      'Even though beginners looking to find a cleaning lady job may want to call around to see if anything is available in their area, it is possible to get a lot of information online in a very short time. By looking at Housekeeper.com, you can find out whether there are available opportunities in your immediate area. If you have a resume and a brief motivation that explains why you are interested in finding a cleaning lady job, it would be far easier to send those out online.',
  },
  {
    header: 'Have a referral network in the field',
    para:
      'One important step in trying to be hired is to develop referral networks with other cleaning staff. These may have more clients than they can handle sometimes and may be able to refer someone over to you. This again could be a great example of knowing the right people and getting your foot in the door.',
  },
  {
    header: 'Become self-employed',
    para:
      'If you are unable to find a cleaning lady job that suits your needs right away or find that it is difficult to get your foot in the door, you can always market yourself and become self-employed. This means being able to set your own hours, choose your own clients, but also means hard work. There are two important aspects that you have to remember if you do start for yourself:',
  },
]

export const bulletPoints = [
  'You have to advertise – You need to have business cards and signs on public bulletin boards or advertise online to make sure people know that your services are available. You can use friends and family as word-of-mouth references here to let them know you are available. One of the best ways to advertise online is by having your services advertised on Housekeeper.com. You not only increase your exposure, but also enhance your credibility by being in a respected website.',
  'A contract with each client – If you are going to work for yourself, you need to make sure that you have a detailed contract that discusses expectations, job description, and liabilities when it comes to the cleaning services provided.',
]

export const articlesJobs = [
  {
    title: ' Cleaning Lady Jobs',
    link: '/Cleaning-Lady',
  },
  {
    title: ' Where Can I Find A Cleaning Lady Job?',
    link: '/where-can-find-a-cleaning-lady-job',
  },
  {
    title: ' Be a Green Cleaning Lady',
    link: '/be-a-green-cleaning-lady',
  },
  {
    title: ' How Professional Cleaning Ladies Clean a Bathroom',
    link: '/how-professional-cleaning-ladies-clean-a-bathroom',
  },
  {
    title: ' How to Be the Best Cleaning Lady',
    link: '/how-to-be-the-best-cleaning-lady',
  },
  {
    title: ' Types of Cleaning Lady Jobs',
    link: '/types-of-cleaning-lady-jobs',
  },
  {
    title: ' Find Cleaning Lady Jobs',
    link: 'https://housekeeper.com/housekeeper-jobs',
  },
]
export const articlesServices = [
  {
    title: ' Where Can I Find a Cleaning Lady?',
    link: '/where-can-i-find-a-cleaning-lady',
  },
  {
    title: ' How to Interview Cleaning Ladies',
    link: '/how-to-interview-cleaning-ladies',
  },
  {
    title: ' Cleaning Lady Interview Questions',
    link: '/how-to-interview-cleaning-ladies',
  },
  {
    title: ' How Much Does a Cleaning Lady Cost?',
    link: '/how-much-does-a-cleaning-lady-cost',
  },
  {
    title: ' What to Include in a Cleaning Lady Contract',
    link: '/what-to-include-in-a-cleaning-lady-contract',
  },
  {
    title: ' Selecting a Cleaning Lady Agency',
    link: '/selecting-a-cleaning-lady-agency',
  },
  {
    title: ' Find Cleaning Ladies',
    link: 'https://housekeeper.com/housekeepers',
  },
]

export const links = [
  {
    title: ' Housekeepers',
    link: 'https://housekeeper.com/housekeeper-atlanta-ga',
  },
  {
    title: ' Atlanta Housekeepers',
    link: 'https://housekeeper.com/housekeeper-atlanta-ga',
  },
  {
    title: ' Austin Housekeepers',
    link: 'https://housekeeper.com/housekeeper-austin-tx',
  },
  {
    title: ' Baltimore Housekeepers',
    link: 'https://housekeeper.com/housekeeper-baltimore-md',
  },
  {
    title: ' Boca Raton Housekeepers',
    link: 'https://housekeeper.com/housekeeper-boca-raton-fl',
  },
  {
    title: ' Boston Housekeepers',
    link: 'https://housekeeper.com/housekeeper-boston-ma',
  },
  {
    title: ' Charlotte Housekeepers',
    link: 'https://housekeeper.com/housekeeper-charlotte-nc',
  },
  {
    title: ' Chicago Housekeepers',
    link: 'https://housekeeper.com/housekeeper-chicago-il',
  },
  {
    title: ' Dallas Housekeepers',
    link: 'https://housekeeper.com/housekeeper-dallas-tx',
  },
  {
    title: ' Denver Housekeepers',
    link: 'https://housekeeper.com/housekeeper-denver-co',
  },
  {
    title: ' Houston Housekeepers',
    link: 'https://housekeeper.com/housekeeper-houston-tx',
  },
  {
    title: ' Las Vegas Housekeepers',
    link: 'https://housekeeper.com/housekeeper-las-vegas-nv',
  },
  {
    title: ' Los Angeles Housekeepers',
    link: 'https://housekeeper.com/housekeeper-los-angeles-ca',
  },
  {
    title: ' Miami Housekeepers',
    link: 'https://housekeeper.com/housekeeper-miami-fl',
  },
  {
    title: ' Minneapolis Housekeepers',
    link: 'https://housekeeper.com/housekeeper-minneapolis-mn',
  },
  {
    title: ' New York Housekeepers',
    link: 'https://housekeeper.com/housekeeper-new-york-ny',
  },
  {
    title: ' Orlando Housekeepers',
    link: 'https://housekeeper.com/housekeeper-orlando-fl',
  },
  {
    title: ' Philadelphia Housekeepers',
    link: 'https://housekeeper.com/housekeeper-philadelphia-pa',
  },
  {
    title: ' Phoenix Housekeepers',
    link: 'https://housekeeper.com/housekeeper-phoenix-az',
  },
  {
    title: ' Sacramento Housekeepers',
    link: 'https://housekeeper.com/housekeeper-sacramento-ca',
  },
  {
    title: ' Saint Louis Housekeepers',
    link: 'https://housekeeper.com/housekeeper-saint-louis-mo',
  },
  {
    title: ' Saint Paul Housekeepers',
    link: 'https://housekeeper.com/housekeeper-saint-paul-mn',
  },
  {
    title: ' San Antonio Housekeepers',
    link: 'https://housekeeper.com/housekeeper-san-antonio-tx',
  },
  {
    title: ' San Diego Housekeepers',
    link: 'https://housekeeper.com/housekeeper-san-diego-ca',
  },
  {
    title: ' San Francisco Housekeepers',
    link: 'https://housekeeper.com/housekeeper-san-francisco-ca',
  },
  {
    title: ' San Jose Housekeepers',
    link: 'https://housekeeper.com/housekeeper-san-jose-ca',
  },
  {
    title: ' Seattle Housekeepers',
    link: 'https://housekeeper.com/housekeeper-seattle-wa',
  },
  {
    title: ' Tampa Housekeepers',
    link: 'https://housekeeper.com/housekeeper-tampa-fl',
  },
  {
    title: ' Toronto Housekeepers',
    link: 'https://housekeeper.com/housekeepers/toronto,ontario',
  },
  {
    title: ' Vancouver Housekeepers',
    link: 'https://housekeeper.com/housekeeper-vancouver-bc',
  },
  {
    title: ' Washington Housekeepers',
    link: 'https://housekeeper.com/housekeeper-washington-dc',
  },
]
